export default "__VITE_ASSET__14512222__"